// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration object
// Replace these values with your actual Firebase project settings
const firebaseConfig = {
    apiKey: "AIzaSyAcpiY6_h_gm0UGOMAXTqrmLobjAMwaXck",
    authDomain: "litvill-assignments.firebaseapp.com",
    projectId: "litvill-assignments",
    storageBucket: "litvill-assignments.firebasestorage.app",
    messagingSenderId: "1075708119684",
    appId: "1:1075708119684:web:e6aae2b580f48e491850d1",
    measurementId: "G-X1MW4NQTMC"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Export the Firebase services for use in other files
export { app, db, auth, storage };